// export const API_SERVER_URL = window.REACT_APP_API_SERVER_URL || 'https://riskmgmtweb.azurewebsites.net';
export const API_SERVER_URL = window.REACT_APP_API_SERVER_URL || 'https://rms.isecurekr.com';
// export const API_SERVER_URL = process.env.REACT_APP_API_SERVER_URL || 'http://localhost:8000';


// ---------------------------------------------------------------
// 사용자 조회 및 업데이트
// ---------------------------------------------------------------
// 취약점 분석결과를 클라이언트가 아닌 서버에서 진행하는 방식에 사용되는 api
// param : {session_id: 첫 호출시 리턴되는 세션고유값}
// example : {session_id: '180a5fc6-9ad0-4e7d-938c-f105716a9b73'}
export function getProcessingPage(sessionId) {
    return API_SERVER_URL + `/processing-page/?session_id=${sessionId}`;
};

// 사용자 인증(토큰 생성)
// param : {username: 사용자ID, password: 패스워드}
// example : {username: isecure, password: isecurepwd}
export function postUserAccounts() {
    return API_SERVER_URL + `/accounts/jwt-token-auth/`;
};

// 사용자 인증(토큰 생성)
// param : {username: 사용자ID, password: 패스워드}
// example : {username: isecure, password: isecurepwd}#
export function postUserAccountsRefresh() {
    return API_SERVER_URL + `/accounts/jwt-token-auth/refresh/`;
};

// 사용자 조회
// param : user=(필수)사용자ID
// example : user=isecure
export function getFindUserInfo(user) {
    return API_SERVER_URL + `/table/filter/staff/?user=${user}`;
};


// 사용자 정보 업데이트(비밀번호 저장)
// param : {username: 사용자ID, password: 패스워드}
// example : {username: isecure, password: isecurepwd}
export function postSaveUserInfo() {
    return API_SERVER_URL + '/accounts/change_password/';
};

// ---------------------------------------------------------------
// 공통코드 조회
// ---------------------------------------------------------------
// 공통코드 전체조회
// param : 
// example : 
export function getAllCodeList() {
    return API_SERVER_URL + `/table/tb_cm_code/`;
};

// 공통코드 조회
// param : code_type=(필수)공통코드유형
// example : code_type=com_cd
export function getFindCodeList(codeType) {
    return API_SERVER_URL + `/table/filter/tb_cm_code/?code_type=${codeType}`;
};

// 필수 공통코드만 조회 (com_cd, asset_type, result_cd, asset_spec)
// example: /table/filter/tb_cm_code/?code_type=com_cd&code_type=asset_type&code_type=result_cd&code_type=asset_spec
export function getEssentialCodeList() {
    return API_SERVER_URL + `/table/filter/tb_cm_code/?code_type=com_cd&code_type=asset_type&code_type=result_cd&code_type=asset_spec`;
};

// ---------------------------------------------------------------
// 로그 조회 및 저장
// ---------------------------------------------------------------
// 로그 조회
// param : companyCode=(필수)회사코드&logType=로그유형&logUser=로그사용자&logYmd=로그일자
// example : companyCode=ISECURE&logType=&logUser=&logYmd=
export function getFindLogList(companyCode, logType, logUser, startYmd, endYmd) {
    return API_SERVER_URL + `/table/filter/tb_cm_log/?companyCode=${companyCode}&logType=${logType}&logUser=${logUser}&startYmd=${startYmd}&endYmd=${endYmd}`;
};

// 로그 저장
// param :  {
//              com_cd: (필수)회사코드,
//              log_type: (필수)로그구분,
//              ....(tb_cm_log 칼럼)
//             }
export function postSaveLog() {
    return API_SERVER_URL + '/create/Log/';
};

// ---------------------------------------------------------------
// 자산목록 조회 및 저장
// ---------------------------------------------------------------
// 자산관리-목록 조회
// param : companyCode=(필수)회사코드&assetType=자산구분&assetName=자산명&assetCd=자산코드&assetSpec=자산스펙
// example : companyCode=ISECURE&assetType=LX&assetName=&assetCd=&assetSpec=
export function getFindAssetList(companyCode, assetType, assetName, assetCd, assetSpec) {
    return API_SERVER_URL + `/table/filter/tb_cm_asset/?companyCode=${companyCode}&assetType=${assetType}&assetName=${assetName}&assetCd=${assetCd}&assetSpec=${assetSpec}`;
    // return API_SERVER_URL+`/api/v1/asset_by_company/?companyCode=${companyCode}&assetType=${assetType}&assetName=${assetName}&assetCd=${assetCd}&assetSpec=${assetSpec}`;
};

// 자산관리-목록 저장
// param :  [{
//              operation: (필수)C/U/D,
//              id: (필수)0,
//              com_cd: (필수)회사코드,
//              asset_type: (필수)자산구분,
//              ....(tb_cm_asset 칼럼)
//             }]
// operation : C = 신규 (이때 id = 0 이어야 함)
//             U = 수정
//             D = 삭제
export function postSaveAsset() {
    return API_SERVER_URL + '/edit/Asset/';
};

// 자산관리-일괄등록
// param :  {
//              companyCode : (필수)회사코드,
//              assetType : 자산구분(없으면 회사전체 자산 삭제 후 저장됨),
//              parsedData : [자산등록csv파일데이타],
//          }
// parsedData : [
//     { com_cd: "TMPL", asset_type: "LX", asset_cd: "LX001", asset_spec: "LINUX", asset_ver: "리눅스", asset_nm: "리묵스서버", 
//         aws_nm: "PROD", vpc_nm: "tri-prod", cluster_nm: "Cluster", os_ver: "OS", asset_qty: "1",  
//         asset_ip: "IP주소",public_ip: "외부IP",  mac_no: "기타IP", depart_nm: "담당팀", manager_nm: "관리자", supervisor_nm: "담당자", location_nm: "설치장소", service_nm: "용도(서비스)", 
//         isms_yn: "Y", rms_yn: "Y", asset_grd: "H", confidential_score: "2", integrity_score: "2", availability_score: "2", asset_rnk: "2", 
//         use_yn: "Y", remark: "비고", val_01: "가변칼럼1", val_02: "가변칼럼2", val_03: "가변칼럼3", } 
//     ]
export function postSaveAssetUpload() {
    return API_SERVER_URL + '/create/AssetUpload/';
};

// ---------------------------------------------------------------
// 템플릿관리/취약점분석 목록 조회 및 저장
// * 템를릿의 경우 회사코드를 TMPL로 조회함
// ---------------------------------------------------------------
// 템플릿관리/취약점분석-목록 조회
// param : companyCode=(필수)회사코드&assetType=자산구분&reportName=보고서명&startYmd=최초분석일자(기간from)&endYmd=최초분석일자(기간to)
// example : companyCode=ISECURE&assetType=LX&reportName=2023&startYmd=20230101&endYmd=20231231
export function getFindAnalysisList(companyCode, assetType, reportName, startYmd, endYmd) {
    return API_SERVER_URL + `/table/filter/tb_va_report/?companyCode=${companyCode}&assetType=${assetType}&reportName=${reportName}&startYmd=${startYmd}&endYmd=${endYmd}`;
};

// 템플릿관리/취약점분석-생성
//  param : {
//             companyCode : (필수)회사코드,
//             assetType : (필수)자산구분,
//             reportName : (필수)보고서명,
//             reportDesc : 보고서 설명,
//             reportOrg : (필수)템플릿
//         }
// example : {
//             companyCode : 'ISECURE',
//             assetType : 'LX',
//             reportName : '[2023-04-16] (주)아이시큐어 (리눅스 서버)',
//             reportDesc : '테스트 보고서입니다',
//             reportOrg : 'TMPL_LX_2023_0001'
//         }
export function postSaveAnalysisCreate() {
    return API_SERVER_URL + '/create/AnalysisReport/';
};

// 템플릿관리/취약점분석-정보 조회
// param : reportId=(필수)보고서ID
// example : reportId=ISECURE_LX_2023_0001
export function getFindReportIdInfo(reportId) {
    return API_SERVER_URL + `/table/filter/tb_va_report/?reportId=${reportId}`;
};

// 템플릿관리/취약점분석-전체 삭제
// param : {reportId : (필수)보고서ID}
// example : {reportId : 'ISECURE_LX_2023_1000'}
export function postDeleteVaReportData(reportId) {
    return API_SERVER_URL + `/delete/VaReport/`;
};

// 취약점분석-레포트 수정
// param : {
//             reportId : (필수)보고서ID,
//             companyCode : (필수)회사코드,
//             assetType : (필수)자산구분,
//             reportName : (필수)보고서명,
//             reportDesc : 보고서 설명,
//             createdYmd : 최초분석일자,
//             updatedYmd : 이행분석일자,
//             confirm : 확정여부
//         }
// example : {
//             reportId : 'ISECURE_LX_2023_0001',
//             companyCode : 'ISECURE',
//             assetType : 'LX'',
//             reportName : '[2023-04-16] (주)아이시큐어 (리눅스 서버)',
//             reportDesc : '보고서 요약정보로 변경하여 사용합니다',,
//             createdYmd : 20230101,
//             updatedYmd : ,
//             confirm : N
//         }
export function postEditVaReportData(reportId) {
    return API_SERVER_URL + `/edit/ReportInfo/`;
};


// DOA 수정 
// param: {
//      doa : (필수)Doa값,
// }
export function getEditDoa() {
    return API_SERVER_URL + `/edit/DoA/`;
};

// 템플릿관리-일괄등록
// param :  {
//              reportId : (필수)템플릿ID,
//              infoType : (필수)업로드유형(measure/suggest/threat),
//              parsedData : [기준정보등록csv파일데이타],
//          }
export function postSaveTemplateUpload() {
    return API_SERVER_URL + '/create/TemplateUpload/';
};


// ---------------------------------------------------------------
// 템플릿관리/취약점분석 분석기준정보 조회
// * 템를릿의 경우 회사코드를 TMPL로 조회함
// ---------------------------------------------------------------
// 분석기준정보-자산목록-조회
// param : reportId=(필수)보고서ID
// example : reportId=ISECURE_LX_2023_0001
export function getFindInfoAssetListData(reportId) {
    return API_SERVER_URL + `/table/filter/tb_va_asset/?reportId=${reportId}`;
};

// 취약점분석 상세페이지 좌측에 자산목록(바로 위에 있는 api와 다른점은 분석 안한 자산은 제외함)
export function getFindInfoAssetListDataOk(reportId) {
    return API_SERVER_URL + `/table/filter/tb_va_asset_vul/?reportId=${reportId}`;
};


// 분석기준정보-자산상세-조회
// param : reportId=(필수)보고서ID&assetCd=(필수)자산코드
// example : reportId=ISECURE_LX_2023_0001&assetCd=LX001
export function getFindAssetInfo(reportId, assetCd) {
    return API_SERVER_URL + `/table/filter/tb_va_asset/?reportId=${reportId}&assetCd=${assetCd}`;
};

// 분석기준정보-진단항목-조회
// param : reportId=(필수)보고서ID
// example : reportId=ISECURE_LX_2023_0001
export function getFindInfoMeasureListData(reportId) {
    return API_SERVER_URL + `/table/filter/tb_va_measure/?reportId=${reportId}`;
};

// 분석기준정보-보안대책-조회
// param : reportId=(필수)보고서ID
// example : reportId=ISECURE_LX_2023_0001
export function getFindInfoSuggestListData(reportId) {
    return API_SERVER_URL + `/table/filter/tb_va_suggest/?reportId=${reportId}`;
};

// 분석기준정보-위험시나리오-조회
// param : reportId=(필수)보고서ID
// example : reportId=ISECURE_LX_2023_0001
export function getFindInfoRiskListData(reportId) {
    return API_SERVER_URL + `/table/filter/tb_va_risk/?reportId=${reportId}`;
};

// 분석기준정보-예외사항(이전 명칭은 조치방안)-조회
// param : reportId=(필수)보고서ID
// example : reportId=ISECURE_LX_2023_0001
export function getFindInfoCorrectiveListData(reportId) {
    return API_SERVER_URL + `/table/filter/tb_va_corrective/?reportId=${reportId}&page=1&page_size=1000&get_total=true`;
};

// 분석기준정보-위협-조회
// param : reportId=(필수)보고서ID
// example : reportId=ISECURE_LX_2023_0001
export function getFindInfoThreatListData(reportId) {
    return API_SERVER_URL + `/table/filter/tb_va_threat/?reportId=${reportId}`;
};

// ---------------------------------------------------------------
// 템플릿관리/취약점분석 분석기준정보 수정 및 저장
// * 템를릿의 경우 회사코드를 TMPL로 조회함
// ---------------------------------------------------------------
// 분석기준정보-자산-저장
// param : reportId : (필수)보고서ID,
//         datas : [{ 
//              operation: (필수)C/U/D,
//              id: (필수)0,
//              report_id: (필수)보고서ID,
//              ....(tb_va_asset 칼럼)
//             }]
// operation : C = 신규 (이때 id = 0 이어야 함)
//             U = 수정
//             D = 삭제
export function postSaveVaAssetData() {
    return API_SERVER_URL + `/edit/VaAsset/`;
};

// 분석기준정보-진단항목-저장
// param : reportId : (필수)보고서ID,
//         datas : [{
//              operation: (필수)C/U/D,
//              id: (필수)0,
//              report_id: (필수)보고서ID,
//              ....(tb_va_measure 칼럼)
//             }]
// operation : C = 신규 (이때 id = 0 이어야 함)
//             U = 수정
//             D = 삭제
export function postSaveVaMeasureData(reportId) {
    return API_SERVER_URL + `/edit/VaMeasure/`;
};

// 분석기준정보-보안대책-저장
// param : reportId : (필수)보고서ID,
//         datas : [{
//              operation: (필수)C/U/D,
//              id: (필수)0,
//              report_id: (필수)보고서ID,
//              ....(tb_va_suggest 칼럼)
//             }]
// operation : C = 신규 (이때 id = 0 이어야 함)
//             U = 수정
//             D = 삭제
export function postSaveVaSuggestData(reportId) {
    return API_SERVER_URL + `/edit/VaSuggest/`;
};

// 위험(Risk)-저장
// param :  reportId : (필수)보고서ID,
//          infoType : "risk"
//          parsedDatas : [{
//              measure: 진단항목코드,
//              risk_desc: 위험시나리오
//             },...]
export function postSaveVaRiskData(reportId) {
    return API_SERVER_URL + `/edit/VaSuggest/`;
};

// 조치방안-저장
// param :  reportId : (필수)보고서ID,
//          infoType : "corrective"
//          parsedDatas : [{
//              measure: 진단항목코드,
//              risk_desc: 조치방안
//             },...]
export function postSaveVaCorrectiveData(reportId) {
    return API_SERVER_URL + `/edit/VaCorrective/`;
};


// 분석기준정보-위협-저장
// param :  reportId : (필수)보고서ID,
//         datas : [{
//              operation: (필수)C/U/D,
//              id: (필수)0,
//              report_id: (필수)보고서ID,
//              ....(tb_va_threat 칼럼)
//             }]
// operation : C = 신규 (이때 id = 0 이어야 함)
//             U = 수정
//             D = 삭제
export function postSaveVaThreatData(reportId) {
    return API_SERVER_URL + `/edit/VaThreat/`;
};


// ---------------------------------------------------------------
// 취약점분석 결과 등록 및 조회
// ---------------------------------------------------------------
// 취약점분석-결과 조회
// resultCd 조건은 진단결과 수정을 위하여 추가됨
// param : reportId=(필수)보고서ID&resultType=(필수)결과구분(C=최초분석,U=이행분석)&assetCd=자산코드&measureCd=진단항목코드&resultCd=진단결과코드(Y/N/SELF)
// example : reportId=ISECURE_LX_2023_0001&resultType=C&resultCd=SELF
export function getFindAnalysisResultList(reportId, resultType, assetCd, measureCd, resultCd, page, pageSize) {
    let url = API_SERVER_URL + `/table/filter/tb_va_result/?reportId=${reportId}&resultType=${resultType}`;

    // Only add parameters if they have values
    if (assetCd) url += `&assetCd=${assetCd}`;
    if (measureCd) url += `&measureCd=${measureCd}`;
    if (resultCd) url += `&resultCd=${resultCd}`;

    // Add pagination parameters
    if (page) url += `&page=${page}`;
    if (pageSize) url += `&page_size=${pageSize}`;
    url += `&get_total=true`;

    return url;
};

// ref 내용 출력
export function getRefDetail(reportId, assetCd = "default") {
    return API_SERVER_URL + `/table/filter/tb_va_result?reportId=${reportId}&measureCd=REF&resultType=C&assetCd=${assetCd}&page=1&page_size=1&get_total=true`;
}

// 취약점분석-결과 등록
// param : {
//             reportId : (필수)보고서ID,
//             resultType : (필수)결과구분,
//             parsedData : [분석결과csv파일데이타],
//         }
// parsedData : [
//     { asset_cd: "LX061", LX1-01-R: "Y", LX1-01-R: "N", LX1-01-R: "Y", ...
//         LX1-01-SA: "■ 현황\☞ UID/GID 정보\root:x:0:0:root:/root:/bin/bash\\root 이외의 UID가 0인 불필요한 사용자가 존재하지 않음\",... },
//     { asset_cd: "LX062", LX1-01-R: "Y", LX1-01-R: "N", LX1-01-R: "Y", ...
//         LX1-01-SA: "■ 현황\☞ UID/GID 정보\root:x:0:0:root:/root:/bin/bash\\root 이외의 UID가 0인 불필요한 사용자가 존재하지 않음\",... } 
//     ]
// *parseData의 [진단항목]-R은 진단결과, [진단항목]-SA는 진단내용으로 저장됨
export function postSaveResultUpload() {
    return API_SERVER_URL + '/create/ResultUpload/';
};

// 취약점분석-결과 분석
// param : {
//             reportId : (필수)보고서ID,
//             resultType : (필수)결과구분(C/U),
//         }
// example : {
//             reportId : 'ISECURE_LX_2023_0001',
//             resultType : 'C'
//         }
export function postSaveResultAnalysis() {
    // return API_SERVER_URL + '/edit/ResultAnalysis/';
    return API_SERVER_URL + '/create/ResultAnalysis/';
};

// 분석기준정보-결과-(수정)저장
// param : reportId : (필수)보고서ID,
//         resultType : (필수)결과구분(C/U),
//         datas : [{
//              operation: (필수)C/U/D,
//              id: (필수)0,
//              report_id: (필수)보고서ID,
//              ....(tb_va_result 칼럼)
//             }]
// operation : U = 수정
export function postModifyResultData(reportId) {
    return API_SERVER_URL + `/edit/RiskMgmt/`;
    // return API_SERVER_URL + `/edit/VaResult/`;
};

export function postModifyVaResultData(reportId) {
    // return API_SERVER_URL + `/edit/RiskMgmt/`;
    return API_SERVER_URL + `/edit/VaResult/`;
};

// 이행결과 - 수정
// param : {
//             reportId : (필수)보고서ID,
//             resultType : (필수)결과구분(C/U),
//         }
// example : {
//             reportId : 'ISECURE_LX_2023_0001',
//             resultType : 'C'
//         }
export function postSaveMeasureStats() {
    return API_SERVER_URL + '/edit/VulnerabilityRemark/';
};

// 통합 보고서 출력
// param : {
//     "reportIds": "reportId1,reportId2,reportId3",
//     "reportType": "consolidated",
//     "consultant": [
//         {
//             name: "홍길동",
//             email: "iii@isecurekr.com",
//             part: "취약점분석"
//         },
//         {
//             name: "이영희",
//             email: "lee@isecurekr.com",
//             part: "보안감사"
//         }
//     ]
// 합
export function postReportAll() {
    return API_SERVER_URL + `/statistics/report/`;
};

// 통합 보고서 리스트
// param : {
//     "reportIds": "totalReportId1,totalReportId2,totalReportId3",
//     "reportType": "consolidated",
//     "consultant": [
//         {
//             name: "홍길동",
//             email: "iii@isecurekr.com",
//             part: "취약점분석"
//         },
//         {
//             name: "이영희",
//             email: "lee@isecurekr.com",
//             part: "보안감사"
//         }
//     ]
// 합
export function getTotalReportList(companyCode, reportName, startDate, endDate) {
    return API_SERVER_URL + `/table/filter/tb_va_con_report/?companyCode=${companyCode}&reportName=${reportName}&startYmd=${startDate}&endYmd=${endDate}`;
};

// 비교 분석 보고서 출력
// param : {
//     "reportIds": "totalReportId1,totalReportId2,totalReportId3",
//     "reportType": "consolidated",
//     "consultant": [
//         {
//             name: "홍길동",
//             email: "iii@isecurekr.com",
//             part: "취약점분석"
//         },
//         {
//             name: "이영희",
//             email: "lee@isecurekr.com",
//             part: "보안감사"
//         }
//     ]
// 합
export function postReportHistory() {
    return API_SERVER_URL + `/create/VulnerabilityComparison/`;
};
// ---------------------------------------------------------------
// 취약점분석 레포트 조회
// ---------------------------------------------------------------
// 자산 상세진단결과
// param : reportId=(필수)보고서ID&assetCd=(필수)자산코드
// example : reportId=ISECURE_LX_2023_0001&assetCd=LX001
export function getFindAssetStatistics(reportId, assetCd) {
    return API_SERVER_URL + `/statistics/asset/?reportId=${reportId}&assetCd=${assetCd}`;
};

// C 취약점분석 통계(항목별통계+진단항목별통계+자산별통계)
// U 이행진단 통계(항목별통계+진단항목별통계+자산별통계+이행진단 전·후 보안수준)
// param : reportId=(필수)보고서ID&resultType=(필수)결과구분
// example : reportId=ISECURE_LX_2023_0001&resultType=C
export function getFindVulnerablityStatistics(reportId, resultType) {
    return API_SERVER_URL + `/statistics/measure/?reportId=${reportId}&resultType=${resultType}`;
};


// 위험분석 통계(항목별통계+진단항목별통계)
// param : reportId=(필수)보고서ID
// example : reportId=ISECURE_LX_2023_0001
export function getFindRiskStatistics(reportId) {
    return API_SERVER_URL + `/statistics/riskeval/?reportId=${reportId}`;
};

// 위험관리 : 결과
// param : reportId=(필수)보고서ID
// example : reportId=ISECURE_LX_2023_0001
export function getFindRiskManagement(reportId) {
    return API_SERVER_URL + `/statistics/riskmgmt/?reportId=${reportId}`;
};

// 이행결과
// param : reportId=(필수)보고서ID
// example : reportId=ISECURE_LX_2023_0001
export function getFindRiskResultManagement(reportId) {
    return API_SERVER_URL + `/statistics/measure/?reportId=${reportId}&resultType=F`;
};
// ---------------------------------------------------------------
// 대시보드 조회
// ---------------------------------------------------------------
// 자산유형별 대상 레포트ID 조회(최종 레포트ID)
// param : companyCode=(필수)회사코드
// example : companyCode=ISECURE
export function getDashBoardReportList(companyCode, assetType) {
    return API_SERVER_URL + `/dashboard/reportlist/?companyCode=${companyCode}&assetType=${assetType}`;
};

// 대시보드 조회
// param : reportIds=(필수)레포트ID들(,로 구분)
// example : reportIds=ISECURE_LX_2023_0001,ISECURE_LX_2023_0002
export function getDashBoardSummary(reportIds) {
    return API_SERVER_URL + `/dashboard/summary/?reportIds=${reportIds}`;
};

// 자산유형별 진단항목 대시보드 조회
// param : reportId=(필수)레포트ID
// example : reportId=ISECURE_LX_2023_0001
export function getDashBoardMeasure(reportId) {
    return API_SERVER_URL + `/dashboard/measure/?reportId=${reportId}`;
};

// 자산별 대상 레포트ID 조회(최종 레포트ID)
// param : reportIds=(필수)레포트ID들(,로 구분)
// example : reportIds=ISECURE_LX_2023_0001,ISECURE_LX_2023_0002
export function getDashBoardAsset(reportIds) {
    return API_SERVER_URL + `/dashboard/asset/?reportIds=${reportIds}`;
};

// 취약점 분석 후 보고서 생성하여 다운로드 받을 수 있는 API
export function getPdfDownload(reportType, reportId, assetCd) {
    let url = API_SERVER_URL + `/statistics/report/?reportType=${reportType}&reportId=${reportId}`;
    if (assetCd) {
        url += `&assetCd=${assetCd}`;
    }
    return url;
};

// 취약점 분석 후 자산별 보고서 생성하여 다운로드 받을 수 있는 API
export function getPdfDownloadAsset(reportType, reportId, assetType) {
    return API_SERVER_URL + `/statistics/report/?reportType=${reportType}&reportId=${reportId}&assetCd=${assetType}`;
    // return API_SERVER_URL+`/statistics/report/?reportType=${reportType}&reportId=${reportId}&assetCd=${assetType}`;
};

// 자산명세서에 기입할 중요코드 목록 API
export function getAssetCommonCodeList(codeType) {
    return API_SERVER_URL + `/table/filter/tb_cm_code/?code_type=${codeType}`;
};

// 취약점 결과 분석 삭제 API
export function postAnalysisDelete() {
    return API_SERVER_URL + `/delete/VulResult/`;
};


// 회사별 환경 설정 및 업데이트
export function getCompanyConfig(codeCd) {
    return API_SERVER_URL + `/table/filter/tb_cm_code/${codeCd}/`;
}

// 회사별 사용중인 자산구분 조회 (tb_cm_asset 테이블 사용)
// param : companyCode=(필수)회사코드
// example : companyCode=COMP001
export function getCompanyAssetTypes(companyCode) {
    return API_SERVER_URL + `/table/filter/tb_cm_asset/?companyCode=${companyCode}`;
}

// 사용자 권한 정보 조회
export function getMyPermissions() {
    return API_SERVER_URL + `/my_permissions/`;
}


// 대시보드 통계 추가 (관리자는 선택 회사 조회 가능)
export function getDashboardHistory(companyCode) {
    return API_SERVER_URL + `/dashboard/history/?companyCode=${companyCode || ''}`;
}

// 대시보드 회사별/자산그룹별 진행현황 (1~5단계)
// 관리자(ISECURE): 최근 4개월 내 자산등록/취약점 리포트작성 회사 전체
// 일반 사용자: 본인 회사만
export function getDashBoardProgress() {
    return API_SERVER_URL + `/dashboard/progress/`;
}


// 수동진단 리포트 self값으로 자동생성 
export function postSaveResultAutoSelf(reportId) {

    return API_SERVER_URL + `/create/CheckList/?reportId=${reportId}`;
}

// 자산 타입 목록 (selecbox에서 사용됨)
export function getAssetTypeList() {
    return API_SERVER_URL + `/stream/code-changes/`;
}